import DataType from '../../Config/DataStructure';
import { MultiplePlayOverviewDataType, MultiplePlayPreviewDataType, MultiplePlayStatsDataType } from '../../Config/GamePreviewDataType';
import CommonGamePreviewData from './CommonGamePreviewData';

export default class MultiplePlayGamePreviewData extends CommonGamePreviewData implements MultiplePlayPreviewDataType {
    constructor(hallID: number, gameID: string, playType: DataType.Enums.PlayType, data: MultiplePlayOverviewDataType) {
        super(hallID, gameID, playType, data);
    }

    public updateOverviewData(data: MultiplePlayOverviewDataType) {
        super.updateOverviewData(data);
    }

    public updateStatsData(data: MultiplePlayStatsDataType) {
        super.updateStatsData(data);
    }
}
